import {
    $SCOPE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
} from '../../../../services/system'

import {
    ORDER_COMPLETE_SERVICE_NAME,
    ORDER_CONTENT_SERVICE_NAME,
    ORDER_RELATED_PACKAGES_SERVICE_NAME,
    ORDER_SERVICE_NAME,
    OrderCompleteService,
    OrderContentService,
    OrderRelatedPackagesService,
    OrderService,
} from '../../../../services/order'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'

import { OrderDirectiveController } from './orders-details.directive.controller'

import * as TEMPLATE from './orders-details.tpl.html'


// Setup


export class OrderDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        ORDER_SERVICE_NAME,
        ORDER_COMPLETE_SERVICE_NAME,
        ORDER_CONTENT_SERVICE_NAME,
        ORDER_RELATED_PACKAGES_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            $scope: any,
            $timeout: ng.ITimeoutService,
            orderService: OrderService,
            orderCompleteService: OrderCompleteService,
            orderContentService: OrderContentService,
            orderRelatedPackages: OrderRelatedPackagesService,
            userSessionService: UserSessionService
        ) => new OrderDirectiveController(
            $scope,
            $timeout,
            orderService,
            orderCompleteService,
            orderContentService,
            orderRelatedPackages,
            userSessionService,
            OrderService.REFERENCE_TYPE,
            OrderService.SIMAX_MODULE_NAME
        )]

    controllerAs = '$ctrl'

    template = TEMPLATE
}

// Setup End